import { AccountPreferences } from 'platform/components/AccountPreferences';
import { AuthGate } from 'platform/components/AuthContext';
import { Layout } from 'platform/components/layout/Layout';
import { ACCOUNT_TAB_NAME, ActiveTabNameContext } from 'platform/components/layout/PrimaryNavBar';
import { LoadingPage } from 'platform/components/LoadingPage';
import { useCommsPreferences } from 'platform/graphql/useCommsPreferences';
import { useCustomerDetails } from 'platform/graphql/useCustomerDetails';

export default function AccountRoute(): RouteComponentOutput {
  return (
    <AuthGate>
      <AccountPage />
    </AuthGate>
  );
}

function AccountPage(): RouteComponentOutput {
  const { data: customerDetails, loading: loadingCustomerInfo, refetch } = useCustomerDetails();
  const { data: commsPreferences, loading: loadingCommsPreferences } = useCommsPreferences();

  if (loadingCustomerInfo || loadingCommsPreferences) {
    return <LoadingPage />;
  }

  return (
    <ActiveTabNameContext.Provider value={ACCOUNT_TAB_NAME}>
      <Layout data-testid="account-settings-page">
        <AccountPreferences
          customerDetails={customerDetails}
          commsPreferences={commsPreferences}
          refetchCustomerDetails={refetch}
        />
      </Layout>
    </ActiveTabNameContext.Provider>
  );
}
